import axios from 'axios'

import { AxiosInterceptor } from '../Config/AxiosInterceptor'

AxiosInterceptor()

const exportService = {
  index: async () => {
    return await axios.get('/admin/employee/export-csv')
  },
}

export default exportService
